// Who manages a Bedrijfspagina's intake forms: its werkgever (Role employer)
// and DFM's own admins. A medewerker (Role user) only books activities -- they
// may still fill in the Invulscope a Share link or the intake mail grants them,
// but the Intakeformulieren-overzicht and its edit surface are not his
// (ClickUp 1240ccecavn). The server refuses those reads and writes as well;
// this only keeps the app from offering them.
//
// The Role, never `updating_role`: that is the Werkgever-switch, a weergave.
// Before /v1/users/me/info lands the store holds a placeholder user (id -1),
// which manages nothing.
//
// Bewust zonder imports: het standalone testscript laadt dit bestand direct.
export function managesIntakeForms(user) {
  return !!user && (user.role === "employer" || user.role === "admin");
}

// Of de Werkgever-schakelaar wordt aangeboden: aan een werkgever en een admin,
// ongeacht het abonnement van de pagina (ADR-0087). Dat abonnement is Zoho's
// "Actieve inschrijvingsmanager" en snoeit in de app niets meer.
export function offersViewRoleSwitch(user) {
  return !!user && (user.role === "employer" || user.role === "admin");
}

// Of de app de Intakeformulieren toont: het menu-item, "Mijn intakeformulieren"
// na Afronden en het overzicht als afsluitbestemming. Dat volgt ook de weergave:
// met de Werkgever-schakelaar uit ziet een werkgever of admin alleen wat een
// medewerker ziet.
export function showsIntakeForms(user) {
  return managesIntakeForms(user) && user.updating_role === "employer";
}

// Of de Bedrijfspagina op `domain` deze gebruiker opent: een admin, of een lid.
// Dezelfde vraag als GET /v1/pages/{domain} stelt (PageController::resolve), en
// MySQL vergelijkt het domein daar zonder hoofdletters. Op het linkpad beslist de
// link en niet het lidmaatschap (ADR-0083), dus wie met een sessie van een andere
// pagina via een Share link invult, is hier geen lid. Voor hem geeft
// /bedrijfspagina een 401 en dus PageUnavailable (ClickUp 1240ccep688).
export function isMemberOfPage(user, domain) {
  if (!user) {
    return false;
  }
  if (user.role === "admin") {
    return true;
  }
  if (typeof domain !== "string" || domain === "") {
    return false;
  }

  const wanted = domain.toLowerCase();
  const pages = Array.isArray(user.pages) ? user.pages : [];
  return pages.some(
    (page) => typeof page?.domain === "string" && page.domain.toLowerCase() === wanted,
  );
}
